import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import data from "../data/biodata.json";
import "./gallery.scss";

const GalleryPage = () => {
  const gallerylist = data?.gallery.images || [];
  const fullView = data?.gallery.fullview || [];
  const [modalOpen, setModalOpen] = useState(false);
  const [initialSlide, setInitialSlide] = useState(0);

  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide,
  };

  const openImage = (index) => {
    setInitialSlide(index);
    setModalOpen(true);
  };

  return (
    <div className="gallery-page mx-auto px-4 pb-20 text-skin-text md:px-6">
      <div className="mb-8 flex items-center justify-between pt-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-5 py-3 text-sm text-skin-text shadow-glass backdrop-blur-xl"
        >
          <img src="images/icons/up.png" width="20" height="20" alt="back" />
          Back to portfolio
        </Link>
      </div>

      <div className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
          Photography
        </p>
        <h1 className="font-display text-4xl font-bold text-skin-text md:text-5xl">
          Gallery
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-7 text-skin-muted">
          A visual archive of architecture, machines, light, mood, and everyday
          frames. Click any image to open the full-screen viewer.
        </p>
      </div>

      <div className="gallery mt-8">
        {gallerylist.map((item, index) => (
          <div key={`${item.title}-${index}`} className="image-holder">
            <button
              type="button"
              className="images w-full text-left transition hover:-translate-y-1"
              onClick={() => openImage(index)}
            >
              <img src={item.image} alt={item.title} />
              <div className="p-4">
                <h4 className="font-display text-lg font-semibold text-skin-text">
                  {item.title}
                </h4>
              </div>
            </button>
          </div>
        ))}
      </div>

      {modalOpen ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="relative w-full max-w-6xl rounded-[2rem] border border-white/10 bg-black/30 p-6 backdrop-blur-xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setModalOpen(false)}
              className="absolute right-4 top-4 z-10 h-12 w-12 rounded-full border border-white/15 bg-white/10 text-2xl text-white"
            >
              ×
            </button>
            <Slider key={initialSlide} className="slick-fullscreen" {...settings}>
              {gallerylist.map((item, index) => (
                <div key={`${item.title}-${index}`} className="px-2">
                  <h4 className="mb-4 text-center font-display text-2xl font-semibold text-white">
                    {item.title}
                  </h4>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-[72vh] w-full rounded-[1.5rem] bg-white/10 object-contain p-3"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ) : null}

      <div className="mt-8 text-center">
        <a
          href={fullView.url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/10 px-6 py-4 text-sm font-medium text-skin-text shadow-glass backdrop-blur-xl"
        >
          View full gallery on Instagram
          <img src={fullView.image} alt={fullView.title} width={25} height={25} />
        </a>
      </div>
    </div>
  );
};

export default GalleryPage;
